<script>
import clonedeep from 'lodash.clonedeep'

export default {
  name: 'UndoRedoMixin',
  data () {
    return {
      // Data properties you watch for a change
      undoRedoData: [],
      undoStack: [],
      redoStack: [],
      isActiveUndoRedo: false
    }
  },
  computed: {
    /**
     * Data to watch for changes
     */
    dataWatcher () {
      let value
      let toWatch = {}

      this.undoRedoData.forEach(key => {
        value = this
        key.split('.').forEach(property => {
          value = value[property]
        })
        toWatch[key] = value
      })

      return toWatch
    },
    /**
     * Check if the user can perform undo action
     */
    canUndo () {
      return (this.undoStack.length > 1) && (!this.isActiveUndoRedo)
    },
    /**
     * Check if the user can perform redo action
     */
    canRedo () {
      return (!!this.redoStack.length) && (!this.isActiveUndoRedo)
    }
  },
  watch: {
    /**
     * Copy the changed data into undo stack if it has been changed
     */
    dataWatcher: {
      handler (value) {
        const isNew = JSON.stringify(value) !== JSON.stringify(this.undoStack[this.undoStack.length - 1])
        if (!this.isActiveUndoRedo && isNew) {
          this.undoStack.push(clonedeep(value))
          this.clearRedo()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /**
     * Update watched data with the perovided one
     *
     * @param {Object} data
     */
    async updateWachedData (_overrideData) {
      let overrideData = clonedeep(_overrideData)
      let originalVariable
      let undoRedoKeys
      let lastKey

      this.undoRedoData.forEach(undoRedoKey => {
        originalVariable = this
        undoRedoKeys = undoRedoKey.split('.')
        lastKey = undoRedoKeys.pop()

        undoRedoKeys.forEach(property => {
          originalVariable = originalVariable[property]
        })
        originalVariable[lastKey] = overrideData[undoRedoKey]
      })
    },
    /**
     * Perform undo action
     */
    undo () {
      if ((!this.canUndo)) {
        return
      }

      const self = this
      self.isActiveUndoRedo = true

      this.redoStack.unshift(this.undoStack.pop())

      this.updateWachedData(this.undoStack[this.undoStack.length - 1])
        .finally(() => {
          self.isActiveUndoRedo = false
        })
    },
    /**
     * Perform redo action
     */
    redo () {
      if ((!this.canRedo)) {
        return
      }

      const self = this
      self.isActiveUndoRedo = true

      this.undoStack.push(this.redoStack.shift())

      this.updateWachedData(this.undoStack[this.undoStack.length - 1])
        .finally(() => {
          self.isActiveUndoRedo = false
        })
    },
    /**
     * Perform undo all action, i.e. reset to initial state
     */
    undoAll () {
      if ((!this.canUndo)) {
        return
      }

      const self = this
      self.isActiveUndoRedo = true
      const originalState = this.undoStack.shift()
      this.redoStack.unshift(...this.undoStack)
      this.undoStack = [originalState]

      this.updateWachedData(originalState)
        .finally(() => {
          self.isActiveUndoRedo = false
        })
    },
    /**
     * Clear undo stack
     */
    clearUndo () {
      this.undoStack = [clonedeep(this.dataWatcher)]
    },
    /**
     * Clear redo stack
     */
    clearRedo () {
      this.redoStack = []
    }
  }
}
</script>
